import { getMediaAssetsBasePath } from '@change/config/mediaAssets';
import { useUtilityContext } from '@change/core/react/utilityContext';

export const useMediaAssetsBasePath = (): string => {
	const {
		environment: { getApiEnvironment },
	} = useUtilityContext();
	const environment = getApiEnvironment();
	return getMediaAssetsBasePath(environment !== 'development' ? environment : 'demo');
};
